<!-- 由 suu 创建于 2022-06-22 Wednesday -->
<!-- 告知书 -->
<template>
  <div class="recipe-cna-notice">
    <img class="cna-img" :src="bgImage" alt="" />
    <div class="cna-btn user-btn" @click="handelStart">我已知晓，谢谢</div>
  </div>
</template>

<script>
export default {
  name: 'recipe-cna-notice',

  components: {},

  props: {},

  data() {
    return {
      showBtn: false,
      bgImage: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-notice-bg'
    }
  },

  computed: {
    id() {
      return this.$route.query.id
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    handelStart() {
      this.$router.replace('/recipe-cna-ques?id=' + this.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.recipe-cna-notice {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
  background-color: #f8f8f8;
  .cna-img {
    width: 100%;
    min-height: 1000px;
  }
  .cna-btn {
    width: 215px;
    height: 50px;
    background: #6759ff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    position: absolute;
    bottom: 56px;
  }
}
</style>
